import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MapStoreMunicipality } from '@app/shared/models/municipality/Municipality';
import { NotificationDialogComponent } from '@app/shared/dialog/notification-dialog/notification-dialog.component';
import { Observable, of } from 'rxjs';
import { debounceTime, filter, map, startWith, tap } from 'rxjs/operators';
import { AddressSearchService } from '../../services/api/address-search.service';

@Component({
  selector: 'app-address-search',
  templateUrl: './address-search.component.html',
  styleUrls: ['./address-search.component.scss'],
})
export class AddressSearchComponent implements OnInit, OnChanges {
  @Input() municipality?: MapStoreMunicipality;
  @Input() placeholder = 'In Karte suchen';
  @Output() selectEvent = new EventEmitter<{ lat: any; lng: any }>();
  filteredOptions: Observable<any[]> = of();
  searchInput: any;
  defaultTypes = 'address';
  searchControl = new FormControl();

  constructor(private addressSearchService: AddressSearchService, public matDialog: MatDialog) {}

  ngOnInit() {
    this.searchControl.valueChanges
      .pipe(
        startWith(''),
        map((x) => {
          return this.lookForSuggestion(x);
        }),
        debounceTime(1000)
      )
      .subscribe((x) => (this.filteredOptions = x));
  }

  lookForSuggestion = (searchTerm: string, count = 5) => {
    return searchTerm === '' ? of([]) : this.addressSearchService.suggest(searchTerm, this.municipality?.key as string, count);
  };

  ngOnChanges(changes: SimpleChanges) {
    this.searchControl.setValue(undefined);
  }

  navigate(e: any) {
    this.addressSearchService.searchByMunicipalityKey(this.municipality?.key as string, e.suggestion).subscribe((x: any) => {
      if (x.features?.length > 0) {
        this.selectEvent.emit({ lat: x?.features[0]?.geometry?.coordinates[1], lng: x?.features[0]?.geometry?.coordinates[0] });
      } else {
        this.selectEvent.emit({ lat: 0, lng: 0 });
      }
    });
  }

  displayFn(e: any) {
    return e && e.suggestion ? e.suggestion : '';
  }

  search = (e: any) => {
    this.filteredOptions = this.lookForSuggestion(e, 20);
    this.filteredOptions
      .pipe(
        filter((x) => x.length === 0),
        tap((x) => {
          this.matDialog.open(NotificationDialogComponent, {
            data: {
              descriptionText: 'Straße nicht vorhanden',
              orientation: 'row',
              alignment: 'start',
            },
            panelClass: ['-md'],
          });
        })
      )
      .subscribe();
  };
}
